import styled from 'astroturf/react';

const Content = styled('p')`
  font-size: 11px;
  line-height: 15px;
  padding: 5px 14px 0px 0px;
  font-family: var(--ph-font-family-source-sans-pro-regular);
`;

const Text = styled('p')`
  font-family: var(--ph-font-family-lato-regular);
  font-size: 11px;
  padding-top: 4px;
  white-space: pre-wrap;
  &[class*='editFromList']{
    padding-left: 8px !important;
    background: var(--light-grayish-blue);
    margin-bottom: 0px; 
    margin-top: 4px; 
  }
  span {
    font-style: italic;
    color: var(--ph-gray-450);
  }
`;

const DatePickerFieldError = styled('div')`
  width: 133px;
  height: 20px;
  display: flex;
  align-items: center;
  position: relative;
  top: 0;
  font-size: 1.2rem;
  color: var(--ph-red-500);
  pointer-events: none;
`;

export default {
  Content,
  Text,
  DatePickerFieldError
}